import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useLanguage } from 'Context/LanguageContext';
import assetConst from 'FielderUtils/roleManagementConst/assetConst';
import inventoryConst from 'FielderUtils/roleManagementConst/inventoryConst';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { useSelector } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import useValidateRoles from '@core/utils/roles/useValidateRoles';

const AssetInventoryTitles = (
  {
    assetInventories,
    activeAssetInventory,
    changeActiveAssetInventory,
    client,
    editAssetInventoryVisibility,
    isAsset,
    isInventory,
  }) => {
  const lan = useLanguage();
  const user = useSelector(selectUser);
  const [canEdit, setCanEdit] = useState(false);
  const { isRoleValid } = useValidateRoles();

  useEffect(() => {
    let hasRole = false;
    const isAllowed =
      RoleUtils.isUserAdministrator(user) ||
      RoleUtils.isUserSuperAdministrator(user) ||
      client;

    if (isAsset) {
      hasRole = isRoleValid(assetConst.ASSETS, assetConst.EDIT_ASSET);
    } else if (isInventory) {
      hasRole = isRoleValid(inventoryConst.INVENTORY, inventoryConst.EDIT_INVENTORY);
    }
    setCanEdit(hasRole && isAllowed);
  }, [isAsset, isInventory, client, user, isRoleValid]);

  const Title = ({ assetInventory, index }) => {
    const selected = activeAssetInventory === index;
    const categoryName = assetInventory.category?.name || '';
    const idCategory = assetInventory.category?.id || '';
    const assetInventoryName = assetInventory?.name || '';

    return (
      <Box
        component="button"
        type="button"
        id={`assetInventory-${index}`}
        role="tab"
        aria-controls="v-pills-home"
        aria-selected={selected ? 'true' : 'false'}
        onClick={() => changeActiveAssetInventory(index)}
        sx={(theme) => ({
          border: 'none',
          padding: 0,
          margin: 0,
          width: '100%',
          textAlign: 'left',
          cursor: 'pointer',
          backgroundColor: 'transparent',
          borderRadius: 1,
          mb: 0.5,
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
          },
          '& > .title-container': {
            borderRadius: 1,
            padding: theme.spacing(1, 1.5),
            border: `1px solid ${
              selected ? theme.palette.divider : 'transparent'
            }`,
            backgroundColor: selected
              ? theme.palette.mode === 'dark'
                ? theme.palette.action.selected
                : theme.palette.action.hover
              : theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create(
              ['background-color', 'border-color'],
              { duration: theme.transitions.duration.shortest }
            ),
            '&:hover': {
              backgroundColor: selected
                ? theme.palette.mode === 'dark'
                  ? theme.palette.action.selected
                  : theme.palette.action.hover
                : theme.palette.action.hover,
            },
          },
        })}
      >
        <Grid container alignItems="center" className="title-container">
          <Grid size={11} sx={{ display: 'flex', alignItems: 'center', pr: 1, }}>
            <Typography variant="body2" sx={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>
              {`[${idCategory} ${categoryName}] - ${assetInventoryName}`}
            </Typography>
          </Grid>
          <Grid size={1} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
            {canEdit && (
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  editAssetInventoryVisibility(true);
                }}
                sx={{ p: 0.25, '&:hover': { backgroundColor: 'transparent' } }}
                aria-label={lan.edit}
              >
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Box>
    );
  };
  return (
    <Box
      role="tablist"
      aria-orientation="vertical"
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        bgColor: 'transparent',
      })}
    >
      {assetInventories?.map((assetInventory, index) => (
        <Title
          id={`assetInventory-title-${index}`}
          assetInventory={assetInventory}
          index={index}
        />
      ))}
    </Box>
  );
};
export default AssetInventoryTitles;
//Original code:
/*import React, { useEffect, useState } from 'react';
import { Icon, IconButton } from '@mui/material'
import { useLanguage } from 'Context/LanguageContext';
import assetConst from 'FielderUtils/roleManagementConst/assetConst';
import inventoryConst from 'FielderUtils/roleManagementConst/inventoryConst';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useSelector } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import useValidateRoles from '@core/utils/roles/useValidateRoles';

const AssetInventoryTitles = ({
	assetInventories,
	activeAssetInventory,
	changeActiveAssetInventory,
	client,
	editAssetInventoryVisibility,
	isAsset,
	isInventory,
}) => {
	const lan = useLanguage();
	const user = useSelector(selectUser);
	const [canEdit, setCanEdit] = useState(false);
	const { isRoleValid } = useValidateRoles();
	useEffect(() => {
		let hasRole = false;
		let isAllowed =
			RoleUtils.isUserAdministrator(user) || RoleUtils.isUserSuperAdministrator(user) || client;
		if (isAsset) {
			hasRole = isRoleValid(assetConst.ASSETS, assetConst.EDIT_ASSET);
		} else if (isInventory) {
			hasRole = isRoleValid(inventoryConst.INVENTORY, inventoryConst.EDIT_INVENTORY);
		}
		setCanEdit(hasRole && isAllowed);
	}, [isAsset, isInventory, client, user]);
	const Title = ({ assetInventory, i }) => {
		let titleClass = '';
		if (activeAssetInventory === i) {
			titleClass = 'active form-active';
		} else {
			titleClass = 'nav-link form-inactive ';
		}
		let categoryName = assetInventory.category?.name || '';
		let idCategory = assetInventory.category?.id || '';
		let assetInventoryName = assetInventory?.name || '';
		return (
			<button
				data-toggle='pill'
				role='tab'
				aria-controls='v-pills-home'
				key={'assetInventory-' + i}
				aria-selected={(activeAssetInventory === i) + ''}
				className={'nav-link ' + titleClass}
				onClick={() => changeActiveAssetInventory(i)}
			>
				<Grid container>
					<Grid size={11}>
						<Typography fontSize={12} >{"["+idCategory+" "+categoryName+'] - '+assetInventoryName}</Typography>
					</Grid>
					<Grid size={1} className='pl-0'>
						{canEdit && (
							<IconButton className='p-0' onClick={() => editAssetInventoryVisibility(true)}>
								<Icon color='disabled' title={lan.edit}>
									edit
								</Icon>
							</IconButton>
						)}
					</Grid>
				</Grid>
			</button>
		);
	};
	return (
		<div className='nav flex-column nav-pills mt-4 ml-3' role='tablist' aria-orientation='vertical'>
			{assetInventories.map((assetInventory, i) => (
				<Title assetInventory={assetInventory} i={i} />
			))}
		</div>
	);
};

export default AssetInventoryTitles;
*/
